import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icon/iconfont.js';
import './assets/icon/iconfont.css';
import myutils from './utils/index';
import axios from 'axios';


//引入路由
import router from "./router";
import store from './store';
import Cookies from 'js-cookie';

//在自定义axios配置文件下面通过生产环境以及开发环境进行判断设置baseURL
const myURL=window.location.href;
//console.log("myURL==",myURL);
//console.log("myURL==",myURL.indexOf('?'));
if(myURL.indexOf('?')>0){
  var queryStr = myURL.substring(myURL.indexOf('?')); // 截取问号后内容
}else{
  var queryStr=""; 
}


//console.log("queryStr==",queryStr);

axios.defaults.baseURL=
process.env.NODE_ENV==="development" ? "" : "https://www.xd475.com/";
//////////////
Vue.prototype.axios=axios;
Vue.prototype.baseUrl=axios;
Vue.prototype.$myutils=myutils;
Vue.use(ElementUI);
Vue.config.productionTip = false;

/*****去掉注册登录后使用下面路由代码******/
///*
router.beforeEach((to,from,next)=>{
  // const token=Cookies.get('token');
  // sessionStorage.setItem('redirectUrl', queryStr);
  console.log("to==",to);
 //  const redirectUrl = sessionStorage.getItem('redirectUrl')
 //  console.log("redirectUrl==",redirectUrl);
   if(to.name=='home'){
     next(
       {
      //  name:'home',
       // query: { redirect: to.fullPath } // 传递完整路径（包含参数）
     })
   }
 })

//*/
/*****去掉注册登录后使用上面路由代码******/

///////////////////////*********** 有注册登录时路由使用下面代码****************/////////////////////
 /*
router.beforeEach((to,from,next)=>{
 const token=Cookies.get('token');
 sessionStorage.setItem('redirectUrl', queryStr);
//  const redirectUrl = sessionStorage.getItem('redirectUrl')
//  console.log("redirectUrl==",redirectUrl);
  if(!token && to.name!=='login'){
    console.log("login");
    next(
      {
      name:'login',
      // query: { redirect: to.fullPath } // 传递完整路径（包含参数）
    })
  }else if(token && to.name==='login'){
    console.log("home");
    next({
      name:'home',
      query: { redirect: queryStr } // 传递完整路径（包含参数）
    });
  }else{    
    console.log("其它");
    next({      
      //  query: { redirect: queryStr } // 传递完整路径（包含参数）
    });
  }
})
*/

///////////////////////*********** 有注册登录时路由使用上面代码****************/////////////////////
/**
 *2025.05.08之前
 *  router.beforeEach((to,from,next)=>{
 const token=Cookies.get('token')
  if(!token && to.name!=='login'){
    next({name:'login'})
  }else if(token && to.name==='login'){
    next({name:'home'});
  }else{
    next();
  }
})
 */
new Vue({ 
  store, 
  router,
  render: h => h(App),
}).$mount('#app')
